module.exports = __webpack_public_path__ + "media/theme/quick response-9c053e3a.svg";